import React from "react";
import { SERVICES } from "../../lib/constants";

export default function Services() {
  return (
    <section id="services" className="bg-[#F4F4F1] border-b-2 border-[#122A1E]" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="font-mono-accent text-[11px] uppercase text-[#4A5550] mb-3">
              ◆ 001 · Services
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter leading-none text-[#0A0E0C] text-4xl md:text-6xl">
              What We Haul
            </h2>
          </div>
          <p className="font-body text-[#4A5550] md:max-w-md text-base leading-relaxed">
            Five specialties. One promise: your gear moves with <em>our</em> drivers, <em>our</em> trucks, on <em>our</em> schedule — coast-to-coast Canadian routes.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-5 auto-rows-[280px]">
          {SERVICES.map((s, i) => {
            // Bento sizing: first item 2x2, others varying
            const layout = [
              "md:col-span-3 md:row-span-2", // rv — big
              "md:col-span-3 md:row-span-1", // motorcycle
              "md:col-span-2 md:row-span-1", // atv
              "md:col-span-2 md:row-span-1", // snowmobile
              "md:col-span-2 md:row-span-1", // marine
            ];
            return (
              <article
                key={s.key}
                className={`group relative overflow-hidden border-2 border-[#122A1E] bg-[#EAEAE5] hover-lift ${layout[i]}`}
                data-testid={`service-card-${s.key}`}
              >
                <img
                  src={s.image}
                  alt={s.alt}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#122A1E] via-[#122A1E]/70 to-transparent pointer-events-none" />
                <div className="relative h-full flex flex-col justify-between p-5 md:p-7">
                  <div className="flex items-center gap-2">
                    <span className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/80 border border-[#F4F4F1]/40 px-2 py-1">
                      {String(i + 1).padStart(2, "0")} · {s.key.toUpperCase()}
                    </span>
                  </div>
                  <div>
                    <h3 className="font-display font-black uppercase tracking-tight text-[#F4F4F1] text-2xl md:text-3xl leading-none mb-2">
                      {s.title}
                    </h3>
                    <p className="text-[#F4F4F1]/80 text-sm md:text-base max-w-md leading-relaxed">
                      {s.blurb}
                    </p>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {s.features.slice(0, 3).map((f) => (
                        <span key={f} className="font-mono-accent text-[9px] uppercase text-[#F4F4F1] bg-[#122A1E]/70 border border-[#F4F4F1]/30 px-2 py-1">
                          {f}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="absolute top-5 right-5 w-10 h-10 bg-[#FF5A00] text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  →
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
